module.exports = __webpack_public_path__ + "img/inspector-proposal.898d0d8d.jpg";